module.exports = __webpack_public_path__ + "img/leaving.8d2cd253.svg";